import { Box, Button, Paper, PaperProps, Typography } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { frontendSettingsAtom } from '../../../atoms/FrontendSettings';
import { useThemeColor } from '../hooks/useThemeColor';
import { Blog } from '../../../interfaces/Blog/Blog';
import { EditableStyleWrapper } from '../StyleEditor/EditableStyleWrapper';

type BlogCardProps = PaperProps & {
  blog: Blog;
};

export const BlogCard = ({ blog, ...props }: BlogCardProps) => {
  const { primary } = useThemeColor();

  const settings = useRecoilValue(frontendSettingsAtom);

  return (
    <EditableStyleWrapper path='blogsWidgetSettings.blogCardSettings.rootStyle'>
      <Paper
        {...props}
        sx={{
          borderRadius: '8px',
          flex: '1 1 0',
          maxWidth: 250,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          cursor: 'pointer',
          ...props.sx,
          ...settings.settingsV2?.blogsWidgetSettings?.blogCardSettings
            ?.rootStyle,
        }}
      >
        <EditableStyleWrapper path='blogsWidgetSettings.blogCardSettings.imageStyle'>
          <Box sx={{ maxHeight: 200, overflow: 'hidden' }}>
            <Box
              component='img'
              src={blog.coverImage}
              alt={blog.title}
              sx={{
                width: '100%',
                height: 'auto',
                borderTopLeftRadius: '8px',
                borderTopRightRadius: '8px',
                display: 'block', // ensures no unexpected whitespace
                ...settings.settingsV2?.blogsWidgetSettings?.blogCardSettings
                  ?.imageStyle,
              }}
            />
          </Box>
        </EditableStyleWrapper>

        <Box
          sx={{
            px: 1.5,
            display: 'flex',
            flexDirection: 'column',
            gap: 1.5,
            flexGrow: 1,
            mb: 2,
          }}
        >
          <EditableStyleWrapper path='blogsWidgetSettings.blogCardSettings.titleStyle'>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: '18px',
                ...settings.settingsV2?.blogsWidgetSettings?.blogCardSettings
                  ?.titleStyle,
              }}
            >
              {blog.title}
            </Typography>
          </EditableStyleWrapper>

          <EditableStyleWrapper path='blogsWidgetSettings.blogCardSettings.descriptionStyle'>
            <Typography
              sx={{
                fontSize: '12px',
                fontWeight: 500,
                ...settings.settingsV2?.blogsWidgetSettings?.blogCardSettings
                  ?.descriptionStyle,
              }}
            >
              {blog.shortDescription}
            </Typography>
          </EditableStyleWrapper>

          <EditableStyleWrapper path='blogsWidgetSettings.blogCardSettings.readMoreButtonStyle'>
            <Button
              sx={{
                width: 'fit-content',
                px: 0,
                mt: 'auto',
                color: primary,
                textTransform: 'none',
                ...settings.settingsV2?.blogsWidgetSettings?.blogCardSettings
                  ?.readMoreButtonStyle,
              }}
            >
              Devamını Oku
            </Button>
          </EditableStyleWrapper>
        </Box>
      </Paper>
    </EditableStyleWrapper>
  );
};
